import { GzYaraDefinitionWebComponent } from './component/GzYaraDefinitionWebComponent';

export { GzYaraDefinitionWebComponent };
